import { useState } from 'react'
import { useIsomorphicLayoutEffect } from 'react-use'

import { useServerHandoffComplete } from './useServerHandoffComplete'

// Credits: https://github.com/tailwindlabs/headlessui/blob/a8bbd0ecee2ac608a6c64e7fce8c1b551444b63d/packages/@headlessui-react/src/hooks/use-id.ts

let id = 0
function generateId() {
	return ++id
}

export function useId(): string | undefined {
	const ready = useServerHandoffComplete()
	const [id, setId] = useState(ready ? generateId : null)

	useIsomorphicLayoutEffect(() => {
		if (id === null) {
			setId(generateId())
		}
	}, [id])

	return id === null ? undefined : `${id}`
}
